/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Stat_ScoreInputs */

const bn_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোর`)
};

const de_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punktzahl`)
};

const el_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σκορ`)
};

const en_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const es_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntaje`)
};

const fr_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const hi_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंक`)
};

const hu_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontszám`)
};

const id_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor`)
};

const it_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punto`)
};

const ja_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スコア`)
};

const ko_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`점수`)
};

const nl_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoren`)
};

const pl_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik`)
};

const pt_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação`)
};

const ru_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счет`)
};

const sv_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Göra`)
};

const tr_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gol`)
};

const uk_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оцінка`)
};

const vi_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm`)
};

const zh_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分数`)
};

const zh_hant_game_stat_score = /** @type {(inputs: Game_Stat_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分數`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {Game_Stat_ScoreInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_stat_score = /** @type {((inputs?: Game_Stat_ScoreInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Stat_ScoreInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_stat_score(inputs)
	if (locale === "de") return de_game_stat_score(inputs)
	if (locale === "el") return el_game_stat_score(inputs)
	if (locale === "en") return en_game_stat_score(inputs)
	if (locale === "es") return es_game_stat_score(inputs)
	if (locale === "fr") return fr_game_stat_score(inputs)
	if (locale === "hi") return hi_game_stat_score(inputs)
	if (locale === "hu") return hu_game_stat_score(inputs)
	if (locale === "id") return id_game_stat_score(inputs)
	if (locale === "it") return it_game_stat_score(inputs)
	if (locale === "ja") return ja_game_stat_score(inputs)
	if (locale === "ko") return ko_game_stat_score(inputs)
	if (locale === "nl") return nl_game_stat_score(inputs)
	if (locale === "pl") return pl_game_stat_score(inputs)
	if (locale === "pt") return pt_game_stat_score(inputs)
	if (locale === "ru") return ru_game_stat_score(inputs)
	if (locale === "sv") return sv_game_stat_score(inputs)
	if (locale === "tr") return tr_game_stat_score(inputs)
	if (locale === "uk") return uk_game_stat_score(inputs)
	if (locale === "vi") return vi_game_stat_score(inputs)
	if (locale === "zh") return zh_game_stat_score(inputs)
	return zh_hant_game_stat_score(inputs)
});